import {
  CHIEFMANAGELIST} from 'actions/chiefManage';
import {reducerPackage} from "../../utils";
export const chiefManageList = reducerPackage(CHIEFMANAGELIST);

